import React from 'react'

import AppearingWrapper from 'Components/Blocks/AppearingWrapper'
import { Button, Column, Text } from 'Components/UI'

import { StripedCircleSvg } from 'Assets/Svg'

import { LANDING_BASIC_HEADER_PADDING_INLINE } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import { TitleContainer } from './styles'

type Props = {
  buttonCaption?: string
  plainText?: string
  subtitle?: string
  title: string
  onClick?: () => void
}

function BasicSectionTitle({
  buttonCaption,
  plainText,
  subtitle,
  title,
  onClick,
}: Props) {
  const { isDesktop } = useResponsiveLayout()

  return (
    <Column alignStart fullWidth px={LANDING_BASIC_HEADER_PADDING_INLINE}>
      <AppearingWrapper kind="expand">
        <TitleContainer>
          {StripedCircleSvg()}

          <Text
            accent
            as="h2"
            bold
            mt={5}
            screen32={!isDesktop}
            screen52={isDesktop}
            uppercase
          >
            {title}
          </Text>
        </TitleContainer>
      </AppearingWrapper>

      {subtitle && (
        <Text accent my={3} screen14={!isDesktop} screen20={isDesktop}>
          {subtitle}
        </Text>
      )}

      {plainText && (
        <Text important mb={6} screen14={!isDesktop} screen20={isDesktop}>
          {plainText}
        </Text>
      )}

      {buttonCaption && (
        <Button large onClick={onClick}>
          {buttonCaption}
        </Button>
      )}
    </Column>
  )
}

export default BasicSectionTitle
